import React, { useContext, useState } from 'react';
import { BannerContext } from '../../contexts/BannerDimensionsContext';
import { BuildCSS } from '../../helpers/buildVideo';
import Button from '@mui/material/Button';
import { EnviarHtmlVideo, ReceberVideo, CriarPasta, DeletarPasta, VerificarStatusVideo } from '../../services/auth'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import './index.css';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import JSZip from 'jszip';
import { useAuth } from '../../hooks/useAuth'
import useLocalStorage from "../../hooks/useLocalStorage";
import { AuthValidatorContext } from '../../contexts/auth';

export default function Video() {
  const { recordHash } = useAuth();
  const formats = [
    'MP4', 'FLV1', 'WMV1', 'GIF', 'WEBM'
  ]
  const [ value, setValue ] = useState(formats[0]);
  const [ configAvancada, setConfigAvancada ] = useState(false)
  const { setVideoModal, setLoading, setError, listaReplicas, master } = useContext(BannerContext);
  const [ userLocalStorage, setUserLocalStorage ] = useLocalStorage('@login-replicate/user', null);
  const { setTokenLocalStorage } = useContext(AuthValidatorContext);
  const [ videoModel, setVideoModel ] = useState({
    html: "",
    duration: master ? parseFloat(master.duration + 1) * 1000 : 0,
    fps: 30,
    width: 0,
    bitrate: 2000000,
    height: 0,
    format: "mp4",
    quality: 100,
    audio: "",
    loop: false,
    bit: false,
    gifQuality: false
  });
  
  async function handleVideoExport() {
    setLoading({show: true, progress: 2});
    const videosBase64 = [];
    try {      
      const currentDate = new Date();
      const currentDayOfMonth = currentDate.getDate();
      const currentMonth = currentDate.getMonth();
      const currentYear = currentDate.getFullYear();
      const currentHour = currentDate.getHours();
      const currentMinutes = currentDate.getMinutes();
      const currentSeconds = currentDate.getSeconds();
      const dateString = `${currentYear}${currentMonth}${currentDayOfMonth}${currentHour}${currentMinutes}${currentSeconds}`;
      var copyListaReplicas = listaReplicas.filter(x => x.pack === true);
      copyListaReplicas.push(master);
      for (var i = 0; i < copyListaReplicas.length; i++) {
        var copyVideoModel = JSON.parse(JSON.stringify(videoModel));
        var copyReplica = JSON.parse(JSON.stringify(copyListaReplicas[i]));
        var base64 = { base64: "", ext: "" };
        copyVideoModel.audio = master.audio ? JSON.stringify(copyReplica.audio) : "";
        copyVideoModel.audioIA = master.audioIA && master.audioIA.b64 ? JSON.stringify(copyReplica.audioIA) : "";
        copyReplica.preset.forEach(element => {
          if (element.customKeyframe) {
            element.customKeyframe.duration = getDuration(element.customKeyframe.keyframe);
          }
        });
        copyVideoModel.width = copyReplica.width;
        copyVideoModel.height = copyReplica.height;
        copyVideoModel.html = BuildCSS(copyReplica);
        var pastaServidor = await CriarPasta();        
        try {
          copyVideoModel.usuario = userLocalStorage.email;
        } catch {}
        var enviarHtml = await EnviarHtmlVideo(copyVideoModel, pastaServidor);
        if (enviarHtml) {
          base64.base64 = enviarHtml.data.base64;
          base64.ext = enviarHtml.data.ext;
        } else {
          for (var j = 0; j < 360; j++) {
            await sleep(10000);
            var statusVideo = await VerificarStatusVideo(pastaServidor, copyVideoModel);
            setLoading({show: true, progress: 100 * i / copyListaReplicas.length +  statusVideo.percentual / (copyListaReplicas.length)});
            if (statusVideo.finalizado) {
              var receberVideo = await ReceberVideo(pastaServidor, copyVideoModel);
              if (receberVideo.finalizado) {
                base64.base64 = receberVideo.blob;
                base64.ext = receberVideo.ext;
                break;
              }
            }
          }
        }
        videosBase64.push({
          banner: copyReplica,
          base64: base64.base64,
          width: copyReplica.width,
          height: copyReplica.height
        })
        DeletarPasta(pastaServidor);
      }
      const zip = new JSZip();
      if(videosBase64.length > 0) {
        for (let i = 0; i < videosBase64.length; i++) {
          const videoBlob = videosBase64[i].base64;
          zip.file(`${copyListaReplicas[i].width}x${copyListaReplicas[i].height}-${videoModel.fps}.${base64.ext}`, videoBlob);
        }
        const resVideo = await recordHash(master, listaReplicas, "video");
        if (resVideo) {
          zip.generateAsync({ type: 'blob' }).then((content) => {
            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(content);
            downloadLink.download = `pack_${dateString}.zip`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });
        }
        
        if (!resVideo.allowed_access) {
          setTokenLocalStorage(null);
          window.location.replace('https://www.reanimateads.com.br')
        }
      }
      setVideoModal(false);
      setLoading({show: false, progress: false});
    } catch (error) {
      setError(
        {
          mensagem: "Erro ao Gerar Vídeo",
          lista: [error],
          show: true
        }
      )
      console.log(error)
      setVideoModal(false);
      setLoading({show: false, progress: false});
    }
  }

  function getDuration(css) {
    try {
      const regex = /\s\d+(\.\d+)?s/;
      const r = css.toLowerCase().split("animation:")[1].split("}")[0];
      const result = r.match(regex);
      const extractedText = result[0].replace("s", "");
      return parseFloat(extractedText).toFixed(1) * 1000;
    } catch {
      return 1000;
    }
  }


	function sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

  function handleChange(key, value) {
    var copyVideoModel = JSON.parse(JSON.stringify(videoModel));
    copyVideoModel[key] = value;
    setVideoModel(copyVideoModel);
  }

  return (
    <div className='modal-video'>
      <div className='container-modal-video'>
        <HighlightOffIcon onClick={() => setVideoModal(false)} style={{ cursor: 'pointer', position: 'absolute', top: 10, right: 10}}/>
        <div style={{fontSize: '18px', fontWeight: 'bold', justifyContent: 'center',  marginBottom: '30px'}}>
          Exportar Vídeo
          </div>
        <div style={{display: 'flex', marginBottom: '10px', justifyContent: 'center'}}>
          <div style={{width: '80px'}}>FPS: </div>
          <input
            onBlur={(e) => handleChange("fps", e.target.value)}
            style={{width: '100px'}}
            placeholder={videoModel.fps}>
          </input>
        </div>
        <div style={{display: 'flex', marginBottom: '10px', justifyContent: 'center'}}>
          <div style={{width: '80px'}}>Duração: </div>
          <input
            onBlur={(e) => handleChange("duration", e.target.value)}
            style={{width: '100px'}}
            placeholder={videoModel.duration}>
          </input>
        </div>
        {/* <div style={{display: 'flex', marginBottom: '10px', justifyContent: 'center'}}>
          <div style={{width: '80px'}}>Peso Estimado: </div>
          <input
            style={{border: 0, fontWeight: 'bold', width: '100px'}}
            value={
              (
                (
                  1.24 * (
                    videoModel.quality * 2000000 * videoModel.duration
                    * (1 - Math.exp(-0.15 * videoModel.fps))
                  ) / 800000 / 1024
                ).toFixed(2)
              ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kb'
            }
          >
          </input>
        </div>   */}
        {/* <div style={{display: 'flex', marginBottom: '10px', justifyContent: 'center'}}>
          <div style={{width: '80px'}}>Bitrate: </div>
          <input
            onBlur={(e) => handleChange("bitrate", e.target.value)}
            style={{width: '100px'}}
            placeholder={videoModel.bitrate}>
          </input>
        </div> */}
        {
          videoModel.format !== "GIF" ?
          <div style={{display: 'flex', marginBottom: '10px', justifyContent: 'center'}}>
            <div style={{width: '80px'}}>Qualidade: </div>
            <input
              onBlur={(e) => handleChange("quality", e.target.value)}
              style={{width: '100px'}}
              placeholder={videoModel.quality}>
            </input>
          </div> :
          <>
          <div>
            <Checkbox onChange={(e) => handleChange("gifQuality", e.target.checked)} {...{ inputProps: { 'aria-label': 'Checkbox demo' } }} />
            <span style={{color: videoModel.format === "GIF" ? 'black' : 'rgba(200,200,200)'}}>Alta Qualidade</span>
          </div>
          <div>
            <Checkbox onChange={(e) => handleChange("loop", e.target.checked)} {...{ inputProps: { 'aria-label': 'Checkbox demo' } }} />
            <span style={{color: videoModel.format === "GIF" ? 'black' : 'rgba(200,200,200)'}}>Loop</span>
          </div>
          </>
        }
        <div style={{display: 'flex', marginBottom: '10px', justifyContent: 'center'}}>
          <Autocomplete          
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            inputValue={videoModel.format}
            onInputChange={(event, newInputValue) => {
              handleChange("format", newInputValue);
            }}
            disablePortal
            id="combo-box-demo"
            options={formats}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Formatos" />}
          />
        </div>
        <Button
          onClick={() => {
            setConfigAvancada(!configAvancada);
          }}
          variant="outlined">
            { configAvancada ? "-" : "+" }
            Configurações Avançadas
        </Button>
        <div className='container-config-avancada' style={{ height: configAvancada ? '50px' : '0', transition: 'height 0.5s, opacity 0.5s', opacity: configAvancada ? '1' : '0' }}>
          <div style={{ opacity: configAvancada ? '1' : '0', transition: 'opacity 0.5s'}}>
            <Checkbox onChange={(e) => handleChange("bit", e.target.checked)} {...{ inputProps: { 'aria-label': 'Checkbox demo' } }} />
            <span>Utilizar formato de 10 bits</span>
          </div>
        </div>
        <Button 
        // disabled={disabledButton()}
        onClick={() => handleVideoExport()} variant="contained">Converter</Button>
      </div>
    </div>
  )  
}